import {
  TimelineItem,
  TimelineItemProps,
} from '@/common/components/timeline/subcomponents/timeline-item/TimelineItem.tsx';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export const TimelineItemSkeleton = (props: Omit<TimelineItemProps, 'icon' | 'lineComponent'>) => {
  return (
    <TimelineItem
      {...props}
      icon={
        <Stack width={56} height={56} justifyContent="center" alignItems="center">
          <Skeleton variant="circular" width={48} height={48} />
        </Stack>
      }
      lineComponent={<Skeleton variant="rectangular" width={2} sx={{ flex: 1 }} />}
    />
  );
};
